import React from "react";
import HeaderRightSide from "./HeaderRightSide";
import HeaderLeftSide from "./HeaderLeftSide";

const HeaderNav = (props) => {
  const navigateToProduct = () => {
    window.location.href = `${window.location.origin}${window.location.pathname}`;
  };

  return (
    <>
      <div
        className={
          "w-[100%] z-50 top-0 md:h-[68px] items-center h-[60px] max-w-full bg-white shadow-lg header-height bg-[linear-gradient(180deg,_rgba(235,115,36,1)_0%,_rgba(198,50,44,1)_100%)] shadow-[0px_4px_12px_0px_rgba(0,0,0,0.12)] fixed"
        }
      >
        <div className="shadow-none h-full">
          <div className="container md:!w-[1044px] md:!max-w-[1044px] mx-auto flex items-center justify-between md:px-0 px-[9px] h-full">
            {/* LEFT SIDE */}
            <HeaderLeftSide {...props} navigateToProduct={navigateToProduct} />

            {/* RIGHT SIDE */}
            <HeaderRightSide {...props} />
          </div>
        </div>
      </div>
      <div className="md:h-[68px] h-[60px]" />
    </>
  );
};

export default HeaderNav;
